import React from 'react';
import { IonContent, IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonButton } from '@ionic/react';

// Components
import { MessageComponent } from './../../components';

export const WebContactMessageComponent = ({ state, pageConfig, handleClick }) => {

    return (
        <>
            <IonContent className="ion-padding ion-text-center">

                <IonGrid>
                    <IonRow className='ion-text-left'>
                        <IonCol>
                            <h1>Status de la operación</h1>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonCard>
                                <IonCardContent className="ion-text-center">

                                    {state.status &&

                                        <MessageComponent
                                            message="¡Tu mensaje fue enviado con éxito!"
                                            urlImage="assets/images/success.png"
                                        >
                                            <IonButton
                                                type="button"
                                                color="primary"
                                                shape="round"
                                                size="undefined"
                                                onClick={() => handleClick(pageConfig.redirectToSuccess)}>Ir al inicio</IonButton>
                                        </MessageComponent>
                                    }

                                    {!state.status &&


                                        <MessageComponent
                                            message="No se ha podido enviar tu mensaje."
                                            urlImage="assets/images/error.png"
                                            subtitle={<span className="text-error">Ha ocurrido un error.</span>}
                                        >
                                            <IonButton
                                                type="button"
                                                color="primary"
                                                shape="round"
                                                size="undefined"
                                                onClick={() => handleClick(pageConfig.redirectToError)}>Volver al inicio</IonButton>
                                        </MessageComponent>
                                    }

                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                    </IonRow>
                </IonGrid>

            </IonContent>
        </>
    )
}
